import { render, staticRenderFns } from "./EditableBoard.vue?vue&type=template&id=56be2a59"
import script from "./EditableBoard.vue?vue&type=script&lang=js"
export * from "./EditableBoard.vue?vue&type=script&lang=js"
import style0 from "./EditableBoard.vue?vue&type=style&index=0&id=56be2a59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports